import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FooterText = (props) => {
  const navigate = useNavigate();

  return (
    <div className={`visual-footer ${props.style}`}>
      <p>
        © {new Date().getFullYear()} MyNextID | All rights reserved |
        <span
          className="clickable"
          onClick={() => {
            navigate("/termsOfService");
          }}
        >
          {" "}
          Terms of service{" "}
        </span>
        |
        <span
          className="clickable"
          onClick={() => {
            navigate("/privacyPolicy");
          }}
        >
          {" "}
          Privacy policy
        </span>
      </p>
    </div>
  );
};

export default FooterText;
